import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Sidebar from "./Sidebar";
import TourHelpButton from "../TourHelpButton";
import TourSpotlight from "../TourSpotlight";
import { TrialBanner } from "../../pages/BillingPage";
import ReportIssueFab from "../ReportIssueFab";
import NotificationBell from "../NotificationBell";

export default function AppLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6ED]">
        <div className="w-8 h-8 border-2 border-rose-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex min-h-screen bg-[#F9F6ED]" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <TrialBanner />
        {/* Fixed top-right utility cluster: notification bell etc. */}
        <div className="fixed top-3 right-4 z-30 flex items-center gap-1">
          <NotificationBell user={user} />
        </div>
        <Outlet />
      </main>
      <ReportIssueFab user={user} />
      <TourHelpButton />
      <TourSpotlight />
    </div>
  );
}
